'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.query = exports.focusedSearch = exports.clickedSearchResults = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
/* istanbul ignore next */
var canUseAnalytics = function canUseAnalytics(window) {
  return window.analytics && window.analytics.track && !(window.analytics instanceof Array);
}; // At least Safari + AdBlock 2.62 overwrite w.a

/* istanbul ignore next */
var shipAnalytics = function shipAnalytics(serviceUrl, log) {
  return fetch(serviceUrl + '/search/analytics', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: (0, _stringify2.default)({ log: log })
  });
};

/* istanbul ignore next */
var clickedSearchResults = exports.clickedSearchResults = function clickedSearchResults(window, serviceUrl, _ref, callback) {
  var searchId = _ref.searchId,
      searchResultRank = _ref.searchResultRank,
      destinationPage = _ref.destinationPage,
      queryTerm = _ref.queryTerm,
      resultName = _ref.resultName,
      searchLatency = _ref.searchLatency,
      resultType = _ref.resultType;

  var body = {
    searchId: searchId,
    location: 'navigation', // navigation | top of map | bottom of map
    searchResultRank: searchResultRank,
    destinationPage: destinationPage,
    sourcePage: window.location.href,
    queryTerm: queryTerm,
    resultName: resultName,
    searchLatency: searchLatency,
    resultType: resultType
  };

  if (serviceUrl) shipAnalytics(serviceUrl, (0, _extends3.default)({ event: 'Clicked Search Results' }, body));
  if (canUseAnalytics(window)) {
    window.analytics.track('Clicked Search Results', body, callback());
  } else {
    callback();
  }
};

/* istanbul ignore next */
var focusedSearch = exports.focusedSearch = function focusedSearch(window, serviceUrl, _ref2) {
  var searchId = _ref2.searchId;

  shipAnalytics(serviceUrl, { event: 'Focused Search', searchId: searchId });

  if (canUseAnalytics(window)) {
    window.analytics.track('Focused Search', {
      location: 'navigation' // navigation | top of map | bottom of map
    });
  }
};

/* istanbul ignore next */
var query = exports.query = function query(serviceUrl, _ref3) {
  var searchId = _ref3.searchId,
      value = _ref3.value,
      spotHits = _ref3.spotHits,
      subregionHits = _ref3.subregionHits,
      geonameHits = _ref3.geonameHits;

  shipAnalytics(serviceUrl, {
    event: 'Query',
    searchId: searchId,
    query: value,
    hits: {
      spots: spotHits,
      subregions: subregionHits,
      geonames: geonameHits
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewSpotSearch/analytics.js
// module id = 173
// module chunks = 0